import jwt_decode from 'jwt-decode';
import { getOrganizerUser } from '../api/User';
import { USER_INFO, REFRESH_TOKEN } from '../api/config';

export function checkIfAuthenticated(role) {
  const decodedToken = decodeJwt();
  const tokenRole = decodedToken?.iss?.split('/')?.at(-1);

  if (Array.isArray(role)) {
    if (role.includes(tokenRole)) {
      return true;
    }
  } else {
    if (tokenRole === role) {
      return true;
    }
  }

  return false;
}

export function getUserRole() {
  const decodedToken = decodeJwt();

  if (decodedToken) {
    const tokenRole = decodedToken.iss?.split('/')?.at(-1);
    return tokenRole;
  }
  return null;
}

export async function login(token, refreshToken, adminOrganizer) {
  let tokenExpireDate = new Date();
  tokenExpireDate.setDate(tokenExpireDate.getDate() + 7);

  localStorage.setItem('token', token);
  localStorage.setItem('refreshToken', refreshToken);
  localStorage.setItem('tokenExpireDate', tokenExpireDate.getTime());

  let user;

  if (adminOrganizer === true) {
    user = await getUser();
  } else if (adminOrganizer === false) {
    user = await getOrganizerUser();
  } else {
    user = await getUser();
  }
  return user;
}

export function logout() {
  localStorage.removeItem('tokenExpireDate');
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
}

export async function getUser() {
  let url = USER_INFO;
  const role = getUserRole();

  if (role === 'organizer') {
    url = url.replace('{role}', 'organizer');
  } else {
    url = url.replace('{role}', 'admin');
  }

  let token = localStorage.getItem('token');

  const data = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Could not get user');
      }
    })
    .then((data) => {
      if (data.organizer) {
        return data.organizer;
      } else {
        return data.user;
      }
    })
    .catch((text) => {
      //console.log(text);
    });

  return data;
}

export function checkTokenExpiration() {
  const tokenExpirationDate = localStorage.getItem('tokenExpireDate');

  const dateNow = new Date();

  if (dateNow.getTime() > tokenExpirationDate) {
    localStorage.removeItem('tokenExpireDate');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  }
}

export async function tryGetNewToken() {
  const refreshToken = localStorage.getItem('refreshToken');
  let role = getUserRole();

  if (role === 'organizerprofile') {
    role = 'organizer';
  }
  const url = REFRESH_TOKEN.replace('{role}', role);

  if (refreshToken === null) {
    logout();
    return null;
  }

  const success = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({ refreshToken: refreshToken }),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Could not retrieve new token');
      }
    })
    .then((data) => {
      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);
      return data.token;
    })
    .catch((text) => {
      //console.log(text);
      return null;
    });

  return success;
}

export function decodeJwt() {
  const token = localStorage.getItem('token');

  try {
    const decodedToken = jwt_decode(token);
    return decodedToken;
  } catch (error) {
    //console.error(error);
    return null;
  }
}
